// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"45ed2bed","498":"a227e7b5","703":"22d37cde"}[chunkId] + ".chunk.js";
};